export const stepsLogin =  [
  {
    selector: '[data-tut="cnpjAlreadyExists"]',
    content: `CNPJ informado já esta cadastrado como usuário do Portal do MEI, digite seu CNPJ e Senha e clique no botão Entrar.`
  },

];
